import { render } from "./ResistanceTable.vue?vue&type=template&id=b438e9c6&scoped=true"
import script from "./ResistanceTable.vue?vue&type=script&lang=js"
export * from "./ResistanceTable.vue?vue&type=script&lang=js"

import "./ResistanceTable.vue?vue&type=style&index=0&id=b438e9c6&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b438e9c6"]])

export default __exports__